import {AbstractBCMProvider} from './abstract';
import {Translation as TranslationModel} from '../model';
import {MANAGEMENT, PROVIDER} from '../../../resources/bcmApi';

export class Translation extends AbstractBCMProvider {
  management = MANAGEMENT.TRANSLATION;
  model = new TranslationModel();
  name = PROVIDER.TRANSLATIONS;
}
